import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/unlocked.svg contains multiple fill colors. Please adjust it so that it has only one fill color.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/unlocked.svg
 */
const IconUnlocked: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M11.976 6.139l2.09-2.09c.192-.198.397-.382.613-.554l-.293.226c.326-.252.683-.46 1.062-.62-.117.049-.226.096-.348.146.404-.17.83-.286 1.263-.345l-.394.05a5.259 5.259 0 011.336 0l-.393-.05c.434.059.86.175 1.263.345l-.348-.147c.379.162.736.37 1.063.62l-.296-.225c.33.255.63.55.886.878l-.227-.295c.258.335.473.701.64 1.09-.05-.115-.096-.226-.146-.348.17.405.284.831.342 1.267l-.048-.39c.055.432.055.871 0 1.304l.048-.388c-.06.434-.175.86-.344 1.264.05-.117.096-.226.146-.348a5.242 5.242 0 01-.642 1.091l.227-.296c-.319.376-.66.734-1.018 1.073l-1.294 1.293-.318.316a1.51 1.51 0 00-.428 1.032 1.463 1.463 0 001.46 1.46c.386-.007.755-.16 1.032-.429l2.048-2.05a6.575 6.575 0 001.82-3.025c.09-.364.152-.734.186-1.108a6.433 6.433 0 00-.115-1.883 6.078 6.078 0 00-.666-1.77 6.763 6.763 0 00-.639-.925 5.508 5.508 0 00-.534-.582A6.322 6.322 0 0018.003.145a6.454 6.454 0 00-3.364.174c-.953.323-1.82.86-2.535 1.569l-2.12 2.124-.07.066c-.268.277-.42.645-.425 1.031a1.462 1.462 0 001.457 1.461 1.536 1.536 0 001.039-.427l-.009-.004zM12.024 15.82l-2.09 2.091a7.168 7.168 0 01-.609.555l.294-.225c-.327.25-.684.457-1.063.618l.344-.144c-.403.169-.826.285-1.259.345l.388-.052a5.014 5.014 0 01-1.33 0l.389.052a5.07 5.07 0 01-1.259-.345l.344.144a5.047 5.047 0 01-1.063-.618l.296.225a4.936 4.936 0 01-.902-.902l.225.296a5.025 5.025 0 01-.622-1.064c.05.115.098.226.148.348a4.997 4.997 0 01-.346-1.262l.05.39a5.175 5.175 0 010-1.331l-.05.39c.06-.434.176-.858.346-1.262-.05.117-.098.225-.148.347a5.02 5.02 0 01.622-1.063l-.225.296c.31-.374.642-.727.997-1.058l1.313-1.314.331-.33c.27-.276.422-.646.426-1.032a1.459 1.459 0 00-1.458-1.458 1.515 1.515 0 00-1.031.426l-2.106 2.104c-.156.158-.314.316-.452.488-.23.272-.438.56-.626.863a7.86 7.86 0 00-.452.954 6.481 6.481 0 00-.34 3.434 6.326 6.326 0 004.478 4.987c.223.065.448.114.677.149.35.057.702.091 1.056.101.578 0 1.155-.075 1.713-.225a6.395 6.395 0 002.829-1.646c.715-.713 1.431-1.431 2.147-2.147l.064-.068c.27-.275.425-.645.43-1.031a1.462 1.462 0 00-1.462-1.458 1.513 1.513 0 00-1.027.426l.013.007z"
      fill="currentColor"
    />
    <path
      d="M8.537 16.503l.904-.903 2.145-2.145 2.586-2.59 2.244-2.243c.364-.364.73-.72 1.09-1.088l.012-.014c.27-.276.422-.646.426-1.032a1.46 1.46 0 00-1.457-1.46c-.386.007-.755.16-1.032.428l-.904.904-2.14 2.146-2.591 2.59-2.244 2.243c-.364.362-.728.721-1.085 1.089l-.015.013a1.5 1.5 0 00-.428 1.032 1.466 1.466 0 001.46 1.46c.384-.007.752-.16 1.029-.428v-.002z"
      fill="currentColor"
    />
    <path
      d="M11.999 24a5.4 5.4 0 100-10.8 5.4 5.4 0 000 10.8z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.207 17.878h-.264v-.942a1.931 1.931 0 00-.57-1.372 1.942 1.942 0 00-2.744 0 1.925 1.925 0 00-.569 1.372v.942h-.267a.353.353 0 00-.355.352v2.829a.354.354 0 00.355.352h4.416a.352.352 0 00.35-.352v-2.83a.353.353 0 00-.352-.351zm-1.925 2.176a.287.287 0 11-.573 0v-.82a.287.287 0 11.573 0v.82zm.774-2.176h-2.118v-.942a1.053 1.053 0 01.308-.75 1.063 1.063 0 011.5 0 1.054 1.054 0 01.308.75l.002.942z"
      fill="currentColor"
    />
    <path d="M11.67 16.261H9.388v1.605h2.282v-1.605z" fill="currentColor" />
  </svg>
);

export default IconUnlocked;
